/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：163
 */

"use strict"

var r
var o
var i
export { r as c }
export { o as a }
export { i as b };
(function (e) {
  e.DEFAULT = "DEFAULT"
  e.PRIMARY = "PRIMARY"
})(r || (r = {}));
(function (e) {
  e.TEMPLATE = "TEMPLATE"
  e.IMAGE = "IMAGE"
})(o || (o = {}));
(function (e) {
  e.CONTAIN = "contain"
  e.STRETCH = "stretch"
})(i || (i = {}))
export default o
